var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.25V16H1.25l2.828-2.828h9.094V4.079L16 1.25zM14.75 0l-2.828 2.828H2.828v9.093L0 14.75V0h14.75zm-4.617 5.867v4.266H5.867V5.867h4.266z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "static/_/_/ugg/shared/assets/svg/roles/all.svg";
export { SvgAll as ReactComponent };